import React from "react";

import { Modal, Stack, Form, Button } from "react-bootstrap";

import editarProducto from "../functions/editarProducto";

function ModalEditarFormularios({
  isModalEditar,
  setIsModalEditar,
  actualizarEstadoProductos,
  productoEditar,
  setProductoEditar,
  usuario,
}) {
  function editarProductoModal() {
    
    //obtener infor del formulario
    const ruc = usuario.ruc;
    const activo = true;
    const codigo = document.getElementById("codigo").value.trim();
    const nombre = document.getElementById("nombre").value.trim().toUpperCase();
    const descripcion = document.getElementById("descripcion").value.trim().toUpperCase();
    const rev = document.getElementById("rev").value.trim().toUpperCase();
    const orden = document.getElementById("orden").value.trim();
    const url = document.getElementById("url").value.trim().toLowerCase();
    const baseDatos = `reglamentos`;
    // enviar informacion a firebase
    const infoProducto = {activo, codigo, nombre, descripcion, rev, orden, url, ruc};
    editarProducto(infoProducto, usuario.email, baseDatos, productoEditar.id);
    //console.log(productoEditar.id);
    
    // cerrar modal
    setProductoEditar(null);
    actualizarEstadoProductos(baseDatos);
    setIsModalEditar(false);
  }

  const [productoEstado, setProductoEstado] = React.useState({
    ...productoEditar,
  });

  return (
    <Modal
      show={isModalEditar}
      onHide={() => {
        setIsModalEditar(false);
        setProductoEditar(null);
      }}
    >
      <Modal.Header>
        <Modal.Title>Editar Formulario</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
        <Stack>
            <Form.Control
              id="codigo"
              placeholder="codigo"
              type="text"
              classdescripcion="mb-1"
              value={productoEstado?.codigo}
              onChange={(e) =>
                setProductoEstado({
                  ...productoEstado,
                  codigo: e.target.value,
                })
              }
            />
            <Form.Control
              id="nombre"
              placeholder="nombre"
              type="text"
              classdescripcion="mb-1"
              value={productoEstado?.nombre}
              onChange={(e) =>
                setProductoEstado({
                  ...productoEstado,
                  nombre: e.target.value,
                })
              }
            />
            <Form.Control
              id="descripcion"
              placeholder="Nombres"
              type="text"
              classdescripcion="mb-1"
              value={productoEstado?.descripcion}
              onChange={(e) =>
                setProductoEstado({
                  ...productoEstado,
                  descripcion: e.target.value,
                })
              }
            />
            <Form.Control
              id="rev"
              placeholder="Revisión"
              type="text"
              classdescripcion="mb-1"
              value={productoEstado?.rev}
              onChange={(e) =>
                setProductoEstado({
                  ...productoEstado,
                  rev: e.target.value,
                })
              }
            />
            <Form.Control
              id="orden"
              placeholder="orden"
              type="number"
              classdescripcion="mb-1"
              value={productoEstado?.orden}
              onChange={(e) =>
                setProductoEstado({
                  ...productoEstado,
                  orden: e.target.value,
                })
              }
            />
            <Form.Control
              id="url"
              placeholder="Url"
              type="text"
              classdescripcion="mb-1"
              value={productoEstado?.url}
              onChange={(e) =>
                setProductoEstado({
                  ...productoEstado,
                  url: e.target.value,
                })
              }
            />
          </Stack>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => {
            setIsModalEditar(false);
            setProductoEditar(null);
          }}
        >
          Cancelar
        </Button>
        <Button variant="primary" onClick={editarProductoModal}>
          Editar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalEditarFormularios;
